import React from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

/** Checkbox multi-select over {value, label} options; value is an array of option values. */
const MultiSelectFilter = ({
  value,
  onChange,
  options,
  placeholder = "Any",
  disabled = false,
  disablePortal = false,
}) => {
  const missing = value
    .filter((v) => !options.some((o) => o.value === v))
    .map((v) => ({ value: v, label: v }));
  const allOptions = [...missing, ...options];
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disabled={disabled}
      value={allOptions.filter((o) => value.includes(o.value))}
      options={allOptions}
      getOptionLabel={(o) => o.label}
      isOptionEqualToValue={(opt, val) => opt.value === val.value}
      onChange={(_e, v) => onChange(v.map((o) => o.value))}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          <Checkbox size="small" checked={selected} sx={{ p: 0.5, mr: 1 }} />
          <span className="truncate text-[13px] text-gray-800">
            {option.label}
          </span>
        </li>
      )}
      renderTags={(selected) => (
        <span className="pl-1 text-sm text-gray-800">
          {selected.length} selected
        </span>
      )}
      disablePortal={disablePortal}
      ListboxProps={{
        sx: { "& .MuiAutocomplete-option": { py: 0.5, minHeight: "auto" } },
      }}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          minHeight: 36,
          flexWrap: "wrap",
          gap: "2px",
          py: "2px !important",
          padding: "0 8px !important",
          fontSize: "14px",
          backgroundColor: "#ffffff",
          borderRadius: "6px",
          boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
          color: "#111827",
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
          borderColor: "#d1d5db",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#d1d5db",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#d1d5db",
            borderWidth: "1px",
          },
        "& .MuiAutocomplete-input": {
          padding: "0 4px !important",
          fontSize: "14px",
        },
        "& .MuiAutocomplete-input::placeholder": {
          color: "#6b7280",
          opacity: 1,
        },
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={value.length ? "" : placeholder} />
      )}
    />
  );
};

export default MultiSelectFilter;
